// extracted by mini-css-extract-plugin
module.exports = {"yegv52r":"yegv52r","yes-club":"yes-club"};